export class BadGateway extends Error {
  constructor() {
    super('Could not process data');
    this.name = 'Could not process data';
  }
}
